import { Button, Input, Modal } from "antd";
import React, { useState } from "react";
import styles from "./News.module.css";
import dark from "./NewsDark.module.css";
import { createEmail } from "../../service";
const News = ({ theme }) => {
  const [email, setEmail] = useState("");

  const submitHandler = () => {
    try {
      createEmail(email);
    } catch (errorr) {
      console.log(errorr);
    }
  };
  return (
    <div className={theme ? styles.newscontainer : dark.newscontainer}>
      <h1 className={theme ? styles.newsletter : dark.newsletter}>
        DOSPUNKS NEWSLETTER
      </h1>
      <div>
        <p className={theme ? styles.newsletterp : dark.newsletterp}>
         Sign up for the DOSPunks news letter to get updates on what's going on in the DAO. Be the first to know about new drops from Max!
        </p>
      </div>

      <Input
        className={theme ? styles.email : dark.email}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        size="large"
        placeholder={"Enter your email"}
      />

      <Button
        onClick={submitHandler}
        className={theme ? styles.subscribebtn : dark.subscribebtn}
      >
        SUBSCRIBE
      </Button>
    </div>
  );
};

export default News;
